import { useRouter } from 'next/router'
import React from "react"
import { connect } from "react-redux"
import * as actions from "@store/actions"
import FetchSpinner from "@components/global/FetchSpinner/FetchSpinner"
import SupplierSignupComplete from "../SupplierSignupComplete/SupplierSignupComplete"
import SupplierSignupForm from "../SupplierSignupForm/SupplierSignupForm"
import SupplierSignupPayment from "../SupplierSignupPayment/SupplierSignupPayment"
import SupplierSignupWait from "../SupplierSignupWait/SupplierSignupWait"

const SupplierSignupWrapper = ({ params, isAuthenticated, userAttributes, authCheck, login }) => {
  const router = useRouter()

  if (typeof isAuthenticated === "undefined") {
    return <SupplierSignupWait />
  }
  if (!isAuthenticated) {
    // prompt sign up for stage
    return <SupplierSignupWait stage="signedout" />
  }
  // signed in wait for attributes to load
  if (!userAttributes.sub) {
    return null
  }

  switch (userAttributes["custom:status"]) {
    case undefined:
    case null:
      // not supplier
      router.push("/become-a-supplier")
      return null
    case "enquired":
      // awaiting approval
      return <SupplierSignupWait stage={userAttributes["custom:status"]} />
    case "waitlisted":
      // waitlisted - rejected enquiry
      return <SupplierSignupWait stage={userAttributes["custom:status"]} />
    case "payment":
      // payment - approved enquiry sent to payment section
      return <SupplierSignupPayment authCheck={authCheck} />
    case "paid":
    case "form":
      // form - payment successful sent to main form
      return <SupplierSignupForm header step={userAttributes["custom:formStage"]} />
    case "review":
      // review - form complete in review by admin
      return <SupplierSignupForm header step={userAttributes["custom:formStage"]} />
    case "complete":
      // complete - review approved supplier live
      return <SupplierSignupComplete userAttributes={userAttributes} />

    default:
      return <FetchSpinner />
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  userAttributes: state.auth.userAttributes,
})

const mapDispatchToProps = (dispatch) => ({
  authCheck: () => dispatch(actions.authCheck()),
  login: (email, password) => dispatch(actions.login(email, password)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSignupWrapper)
